import { render } from "./tab.html?vue&type=template&id=ca3ce4a6&scoped=true&external"
import script from "./tab.ts?vue&type=script&lang=js&external"
export * from "./tab.ts?vue&type=script&lang=js&external"

import "./tab.scss?vue&type=style&index=0&id=ca3ce4a6&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3ce4a6"],['__file',"src/components/ui/tab/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca3ce4a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca3ce4a6', __exports__)) {
    api.reload('ca3ce4a6', __exports__)
  }
  
  module.hot.accept("./tab.html?vue&type=template&id=ca3ce4a6&scoped=true&external", () => {
    api.rerender('ca3ce4a6', render)
  })

}


export default __exports__